import { PILLAR_ID } from '@/models/pillars'

import pillars from './'
import {
  getLastLoginDate,
  getStoragePillars,
  setLastLoginDate,
  setStoragePillars
} from './storage'

const togglePillar = (store, { id: pillarId, isOpen }) => {
  store.commit('togglePillar', { id: pillarId, isOpen })
  store.dispatch('ui/channelBar/handleMenu', store.getters.openPillars, {
    root: true
  })
}

const openPillarFromTab = (
  store,
  {
    actualPillarId,
    tabToOpen,
    updateStorage = false,
    closeUnrelatedPillar = false
  }
) => {
  const openPillars = store.getters.pillars.filter(pillar =>
    pillar.tabs.find(tab => tab === tabToOpen)
  )
  const dontHaveChannelTab = pillar => {
    return !pillar.tabs.find(tab => tab === PILLAR_ID.CHANNEL)
  }
  //Dont let new tab open with channel
  const openOn = openPillars.find(pillar => {
    return pillar.id !== actualPillarId && dontHaveChannelTab(pillar)
  })

  if (openOn) {
    store.commit('setPillarActiveTab', {
      pillar: openOn.id,
      tab: tabToOpen,
      updateStorage
    })
    if (closeUnrelatedPillar) {
      const relatedPillars = [actualPillarId, openOn.id]
      store.commit('closeUnrelatedPillar', relatedPillars)
    }
  } else {
    const notChannelPillar = store.getters.pillars.find(pillar =>
      dontHaveChannelTab(pillar)
    )
    store.commit('openPillarFromTab', {
      actualPillarId: actualPillarId,
      targetTab: tabToOpen,
      isCloseUnrelatedPillar: closeUnrelatedPillar,
      notChannelPillar
    })
  }

  store.dispatch('ui/channelBar/handleMenu', store.getters.openPillars, {
    root: true
  })
}

const setTabsByLoggedUser = async store => {
  const storagePillars = getStoragePillars()
  const resetDate = await store.dispatch(
    'featureConfig/getFeatureFlagById',
    {
      id: 'ehr-date_reset_pillars'
    },
    { root: true }
  )
  const shouldSetTabPreset =
    shouldForceResetPillars(resetDate) || !storagePillars

  if (shouldSetTabPreset) {
    store.commit(
      'setTabsByPreset',
      store.rootState.permissions.pillars.pillarsPreset
    )
  } else {
    const pillarsAfterPermissionCheck = getPillarsWithPermissionCheck(
      store.rootState.permissions.pillars.visibleTabs,
      storagePillars
    )
    store.commit('setTabsByStorage', pillarsAfterPermissionCheck)
  }

  setLastLoginDate()
}

const getPillarsWithPermissionCheck = (visibleTabs, storagePillars) => {
  let hasChanges = false
  const pillars = Object.keys(storagePillars).reduce((pillars, key) => {
    const pillar = storagePillars[key]
    const tabs = []

    pillar.tabs?.forEach(tab => {
      if (visibleTabs.includes(tab)) {
        tabs.push(tab)
      }
    })
    if (pillar.tabs.length !== tabs.length) {
      hasChanges = true
    }
    pillar.tabs = tabs
    if (!visibleTabs.includes(pillar.activeTab)) {
      pillar.activeTab = tabs[0]
      hasChanges = true
    }
    return {
      ...pillars,
      [key]: pillar
    }
  }, {})
  if (hasChanges) {
    setStoragePillars(pillars)
  }
  return pillars
}

/**
 * Reset pillars if user dont have login date in storage or login date is
 * less than date setted on 'ehr-date_reset_pillars' feature flag
 *
 * If you want user to reset pillars tabs just change the date on the feature flag
 * Ex:
 * Time now is 10/03/2023, 10:40:00
 * Set feature flag to:
 * 2023-03-10T10:41:00
 *
 *
 * @param {Feature flag: string} dateToReset
 * @returns boolean
 */
const shouldForceResetPillars = dateToReset => {
  const lastLogin = getLastLoginDate()
  const dateReset = Date.parse(dateToReset)

  return lastLogin === null || lastLogin < dateReset
}

const removeHiddenTab = (store, tabId) => {
  store.commit('removeHiddenTabFromPillars', tabId)
}

const resetState = async store => {
  /**
   * Channel dont reset like other modules because have
   * to clear listeners before set to initial state
   */
  await store.dispatch('channel/clearState')
  await store.dispatch('refreshControl/clearListener')
  const modules = { ...pillars.modules }
  delete modules.channel

  store.commit('resetState', modules)
}

/**
 * Set up clinical record opened in a draft state to other pillars use it
 * @param {*} store
 * @param {*} draftClinicalRecordId
 */
const updateDraftClinicalRecordId = (store, draftClinicalRecordId) => {
  store.commit('updateDraftClinicalRecordId', draftClinicalRecordId)
}

export default {
  togglePillar,
  openPillarFromTab,
  setTabsByLoggedUser,
  resetState,
  removeHiddenTab,
  updateDraftClinicalRecordId
}
